export const STRIPE_PAYMENT_METHODS = {
	STRIPE_CONNECT: {
		code: 'StripeConnect',
		country: 'US',
		currency: 'usd',
		isSmallestUnit: false,
	},
	STRIPE_JYP: {
		code: 'StripeJPY',
		country: 'JP',
		currency: 'jpy',
		isSmallestUnit: true,
	},
	STRIPE_SGD: {
		code: 'StripeSGD',
		country: 'SG',
		currency: 'sgd',
		isSmallestUnit: false,
	},
} as const;

export type PaymentMethodCode = typeof STRIPE_PAYMENT_METHODS[keyof typeof STRIPE_PAYMENT_METHODS]['code'];
